import PerfectScrollbar from 'react-perfect-scrollbar';
import { useEffect, useState } from 'react';
import { getAllKmzs } from './functions/get_all_kmz.function';
import { useAtom, useAtomValue } from 'jotai';
import {
  allKmzs,
  kmzNetwork,
  partnerForkmzNetwork,
  regionForkmzNetwork,
  citiesKmz,
  regionsKmz,
  cityForkmzNetwork,
} from '../../common/atom/atoms';
import { formatDateWithAtTime } from './functions/format_date_with_at_time.function';
import { getPartnerColor } from './functions/get_color_for_partners.function';
import LongMenu from './kmz_delete_edit_popup.component';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import DeleteKmzComponent from './delete_kmz_popup.component';
import { Tooltip, Typography } from '@mui/material';
import { Autocomplete, TextField, Popper, styled } from '@mui/material';

export const KmzLeftBarComponent = () => {
  let visibleCities;
  let hiddenCitiesCount;
  let allCitiesText;
  const CustomPopper = (props) => {
    return (
      <Popper
        {...props}
        placement="bottom-end"
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 4], // [horizontal offset, vertical offset]
            },
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 8,
            },
          },
        ]}
        style={{ width: 200 }}
      />
    ); // 👈 Set your desired width
  };
  const allKmzData = useAtomValue(allKmzs);
  const [regionNetwork, setRegionNetwrok] = useAtom(regionForkmzNetwork);
  const [cityNetwork, setCityNetwrok] = useAtom(cityForkmzNetwork);
  const [partnerKmz, setPartnerKmz] = useAtom(partnerForkmzNetwork);
  const allCities = useAtomValue(citiesKmz);
  const allRegions = useAtomValue(regionsKmz);
  allKmzData?.map((kmz) => {
    const maxVisibleCities = 2;
    visibleCities = kmz?.cities?.slice(0, maxVisibleCities);
    hiddenCitiesCount = kmz?.cities?.length - maxVisibleCities;
    allCitiesText = kmz?.cities?.join(', ');
  });
  const handleChangeRegion = (event) => {
    setRegionNetwrok(event.target.value);
  };
  const handleChangeCity = (event) => {
    setCityNetwrok(event.target.value);
  };
  const handlePartner = (event) => {
    setPartnerKmz(event.target.value);
  };
  return (
    <>
      <div className="drawer-content" style={{ height: '73vh' }}>
        <div className="alerts_list_main" style={{ height: '71vh', width: 380, marginTop: '10%' }}>
          <PerfectScrollbar>
            <div style={{ padding: '5px', marginTop: '2%', display: 'grid', gap: '20px' }}>
              <div
                style={{
                  width: 344,
                  boxSizing: 'border-box',
                  height: allKmzData?.length ? 724 : null,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingBottom: 16,
                  background: 'white',
                  flexDirection: 'column',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: 24,
                  display: 'inline-flex',
                }}
              >
                <div
                  style={{
                    paddingTop: '3px',
                    paddingBottom: 1,
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    gap: 12,
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      width: 340,
                      marginLeft: '2px',
                      marginRight: '2px',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      display: 'inline-flex',
                    }}
                  >
                    <div style={{ width: 114 }}>
                      {/* <div style={{ alignSelf: 'stretch', height: 32, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', display: 'flex' }}>
                                                <div style={{ alignSelf: 'stretch', paddingLeft: 8, paddingRight: 8, paddingTop: 6, paddingBottom: 6, background: 'white', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 4, overflow: 'hidden', border: '1px #C8CCD2 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex' }}>
                                                    <div style={{ flex: '1 1 0', height: 17, justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'flex' }}>
                                                        <div style={{ flex: '1 1 0', color: '#999FA7', fontSize: 14, fontFamily: 'Poppins', fontWeight: '400', lineHeight: 16.80, wordWrap: 'break-word' }}>Filter by network</div>
                                                    </div>
                                                    <div data-svg-wrapper style={{ position: 'relative' }}>
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69344 7.09327C3.91808 6.83119 4.31265 6.80084 4.57472 7.02548L10.0013 11.6768L15.4279 7.02548C15.69 6.80084 16.0845 6.83119 16.3092 7.09327C16.5338 7.35535 16.5035 7.74991 16.2414 7.97455L10.4081 12.9745C10.174 13.1752 9.82862 13.1752 9.59457 12.9745L3.76124 7.97455C3.49916 7.74991 3.46881 7.35535 3.69344 7.09327Z" fill="#999FA7" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div> */}
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          Partner
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={partnerKmz}
                          label="Partner"
                          onChange={handlePartner}
                          size="small"
                        >
                          <MenuItem value={''}>Select All</MenuItem>
                          <MenuItem value={'zong'}>Zong</MenuItem>
                          <MenuItem value={'cybernet'}>Cybernet</MenuItem>
                          <MenuItem value={'multinet'}>Multinet</MenuItem>
                          <MenuItem value={'wateen'}>Wateen</MenuItem>
                          <MenuItem value={'optix'}>Optix</MenuItem>
                          <MenuItem value={'ptcl'}>Ptcl</MenuItem>
                          <MenuItem value={'ufone'}>Ufone</MenuItem>
                          <MenuItem value={'jazz'}>Jazz</MenuItem>
                          <MenuItem value={'telenor'}>Telenor</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        width: 104,
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        display: 'inline-flex',
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          Region
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={regionNetwork}
                          label="Region"
                          onChange={handleChangeRegion}
                          name="Region"
                          size="small"
                        >
                          <MenuItem value={''}>Please Select</MenuItem>
                          {allRegions?.map((rg) => (
                            <MenuItem value={rg.region}>{rg.region}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div
                      style={{
                        width: 104,
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        display: 'inline-flex',
                      }}
                    >
                      <Autocomplete
                        size="small"
                        options={allCities || []}
                        getOptionLabel={(option) => option.city || ''}
                        value={allCities?.find((ct) => ct.city === cityNetwork) || null}
                        onChange={(event, newValue) => {
                          setCityNetwrok(newValue ? newValue.city : '');
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="City" variant="outlined" />
                        )}
                        PopperComponent={CustomPopper}
                        renderOption={(props, option) => (
                          <li {...props}>
                            <Tooltip title={option.city}>
                              <span
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: 'block',
                                  maxWidth: '110px',
                                }}
                              >
                                {option.city}
                              </span>
                            </Tooltip>
                          </li>
                        )}
                      />
                    </div>

                    {/* <div style={{ borderRadius: 4, justifyContent: 'flex-start', alignItems: 'flex-start', gap: 8, display: 'flex' }}> */}
                    {/* <div style={{ width: 32, height: 16, position: 'relative', borderRadius: 2.67 }}>
                                                <div style={{ width: 32, height: 16, left: 0, top: 0, position: 'absolute', background: '#D9D9D9', borderRadius: 10.67 }} />
                                                <div style={{ width: 10.67, height: 10.67, left: 18.67, top: 2.67, position: 'absolute', background: 'white', boxShadow: '0px 1.3333333730697632px 5.333333492279053px rgba(0, 0, 0, 0.16)', borderRadius: 9999 }} />
                                            </div>
                                            <div style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 2, display: 'inline-flex' }}>
                                                <div style={{ color: '#192435', fontSize: 12, fontFamily: 'Plus Jakarta Sans', fontWeight: '400', lineHeight: 16.80, wordWrap: 'break-word' }}>Show my network</div>
                                            </div> */}
                    {/* switch
                                        </div> */}
                  </div>
                  {/* <div style={{ width: 340, height: 0, border: '1px rgba(0, 0, 0, 0.08) dotted' }}></div> */}
                  {/* <div data-svg-wrapper>
                                        <svg width="340" height="20" viewBox="0 0 340 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="8.5" y="2.5" width="15" height="15" rx="7.5" fill="#FF6066" fill-opacity="0.12" />
                                            <rect x="8.5" y="2.5" width="15" height="15" rx="7.5" stroke="#BD1D23" />
                                            <path d="M15.375 11.875L20.25 7L21 7.75L15.375 13.375L12 10L12.75 9.25002L15.375 11.875Z" fill="#BD1D23" />
                                            <rect x="284.5" y="0.5" width="19" height="19" rx="3.5" stroke="#BDBDBD" stroke-opacity="0.5" />
                                            <path d="M290 8H298V14.5C298 14.7761 297.776 15 297.5 15H290.5C290.224 15 290 14.7761 290 14.5V8ZM291.5 6.5V5.5C291.5 5.22386 291.724 5 292 5H296C296.276 5 296.5 5.22386 296.5 5.5V6.5H299V7.5H289V6.5H291.5ZM292.5 6V6.5H295.5V6H292.5ZM292.5 10V13H293.5V10H292.5ZM294.5 10V13H295.5V10H294.5Z" fill="#757F82" fill-opacity="0.7" />
                                            <rect x="312.5" y="0.5" width="19" height="19" rx="3.5" stroke="#BDBDBD" stroke-opacity="0.5" />
                                            <path d="M316 9.99139C316.522 7.15171 319.01 5 322 5C324.99 5 327.478 7.15171 328 9.99139C327.478 12.831 324.99 14.9828 322 14.9828C319.01 14.9828 316.522 12.831 316 9.99139ZM322 12.7644C323.531 12.7644 324.773 11.5229 324.773 9.99139C324.773 8.45991 323.531 7.2184 322 7.2184C320.469 7.2184 319.227 8.45991 319.227 9.99139C319.227 11.5229 320.469 12.7644 322 12.7644ZM322 11.6552C321.081 11.6552 320.336 10.9103 320.336 9.99139C320.336 9.07248 321.081 8.32759 322 8.32759C322.919 8.32759 323.664 9.07248 323.664 9.99139C323.664 10.9103 322.919 11.6552 322 11.6552Z" fill="#757F82" fill-opacity="0.7" />
                                        </svg>
                                    </div> */}
                </div>
                {allKmzData?.length ? (
                  <div
                    style={{
                      alignSelf: 'stretch',
                      height: 418,
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'flex-start',
                      gap: 16,
                      display: 'flex',
                    }}
                  >
                    {allKmzData?.map((kmz) => (
                      <div
                        style={{
                          alignSelf: 'stretch',
                          height: 134,
                          paddingTop: 8,
                          paddingBottom: 16,
                          paddingLeft: 8,
                          paddingRight: 8,
                          background: 'white',
                          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.04)',
                          borderBottom: `1px ${getPartnerColor(kmz.partner)} solid`,
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          alignItems: 'flex-start',
                          gap: 2,
                          display: 'flex',
                        }}
                      >
                        <div
                          style={{
                            alignSelf: 'stretch',
                            justifyContent: 'flex-start',
                            alignItems: 'flex-start',
                            gap: 8,
                            display: 'inline-flex',
                          }}
                        >
                          <div data-svg-wrapper style={{ position: 'relative' }}>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="15"
                                height="15"
                                rx="7.5"
                                fill={getPartnerColor(kmz.partner)}
                                fill-opacity="0.12"
                              />
                              <rect
                                x="0.5"
                                y="0.5"
                                width="15"
                                height="15"
                                rx="7.5"
                                stroke={getPartnerColor(kmz.partner)}
                              />
                              <path
                                d="M7.375 9.875L12.25 5L13 5.75L7.375 11.375L4 8.00001L4.75 7.25002L7.375 9.875Z"
                                fill={getPartnerColor(kmz.partner)}
                              />
                            </svg>
                          </div>
                          <div
                            style={{
                              flex: '1 1 0',
                              flexDirection: 'column',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              gap: 2,
                              display: 'inline-flex',
                            }}
                          >
                            <div
                              style={{
                                alignSelf: 'stretch',
                                height: 20,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 8,
                                  display: 'flex',
                                }}
                              >
                                <div
                                  style={{
                                    color: '#090C0D',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  File Name:
                                </div>
                                <div
                                  style={{
                                    color: '#757F82',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    fontWeight: '500',
                                    maxWidth: '150px',
                                    textOverflow: 'ellipsis',
                                    wordWrap: 'break-word',
                                  }}
                                  title={kmz.fileName}
                                >
                                  {kmz.fileName}
                                </div>
                              </div>
                              {/* <div data-svg-wrapper> */}
                              <div
                                data-svg-wrapper
                                style={{ display: 'flex', alignItems: 'center' }}
                              >
                                {/* <svg width="40" height="20" viewBox="0 0 40 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M4 9.99139C4.52161 7.15171 7.00952 5 10 5C12.9905 5 15.4784 7.15171 16 9.99139C15.4784 12.831 12.9905 14.9828 10 14.9828C7.00952 14.9828 4.52161 12.831 4 9.99139ZM10 12.7644C11.5315 12.7644 12.773 11.5229 12.773 9.99139C12.773 8.45991 11.5315 7.2184 10 7.2184C8.46851 7.2184 7.227 8.45991 7.227 9.99139C7.227 11.5229 8.46851 12.7644 10 12.7644ZM10 11.6552C9.0811 11.6552 8.3362 10.9103 8.3362 9.99139C8.3362 9.07248 9.0811 8.32759 10 8.32759C10.9189 8.32759 11.6638 9.07248 11.6638 9.99139C11.6638 10.9103 10.9189 11.6552 10 11.6552Z" fill="#757F82" fill-opacity="0.7" />

                                                            </svg> */}
                                <LongMenu kmz={kmz} />
                              </div>
                            </div>
                            <div
                              style={{
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 8,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  color: '#090C0D',
                                  fontSize: 12,
                                  fontFamily: 'Poppins',
                                  fontWeight: '500',
                                  wordWrap: 'break-word',
                                }}
                              >
                                Name:
                              </div>
                              <div
                                style={{
                                  color: '#757F82',
                                  fontSize: 12,
                                  fontFamily: 'Poppins',
                                  fontWeight: '500',
                                  wordWrap: 'break-word',
                                }}
                              >
                                {kmz.name}
                              </div>
                            </div>
                            <div
                              style={{
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 8,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  color: '#090C0D',
                                  fontSize: 12,
                                  fontFamily: 'Poppins',
                                  fontWeight: '500',
                                  wordWrap: 'break-word',
                                }}
                              >
                                Region:
                              </div>
                              {kmz?.regions?.map((region) => (
                                <div
                                  style={{
                                    color: '#757F82',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  {region}
                                </div>
                              ))}
                            </div>
                            <div
                              style={{
                                justifyContent: 'flex-start',
                                alignItems: 'flex-start',
                                gap: 8,
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 8,
                                  display: 'inline-flex',
                                  cursor: 'default',
                                  marginBottom: '8px', // optional spacing between rows
                                }}
                              >
                                <div
                                  style={{
                                    color: '#090C0D',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  City:
                                </div>
                                {/* 
                                                                    {kmz.cities?.map((city, idx) => (
                                                                        <div key={idx} style={{
                                                                            color: '#757F82',
                                                                            fontSize: 12,
                                                                            fontFamily: 'Poppins',
                                                                            fontWeight: '500',
                                                                            wordWrap: 'break-word'
                                                                        }}>
                                                                            {city}
                                                                        </div>
                                                                    ))} */}
                                <Box display="flex" gap={1} flexWrap="wrap">
                                  {kmz.cities.slice(0, 2).map((city, idx) => (
                                    <Typography
                                      key={idx}
                                      sx={{
                                        color: '#757F82',
                                        fontSize: 12,
                                        fontFamily: 'Poppins',
                                        fontWeight: 500,
                                        wordWrap: 'break-word',
                                      }}
                                    >
                                      {city}
                                    </Typography>
                                  ))}

                                  {kmz.cities.length > 2 && (
                                    <Tooltip title={kmz.cities.slice(2).join(', ')} arrow>
                                      <Typography
                                        sx={{
                                          color: '#BD1D23',
                                          fontSize: 12,
                                          fontFamily: 'Poppins',
                                          fontWeight: 500,
                                          cursor: 'pointer',
                                        }}
                                      >
                                        +{kmz.cities.length - 2} more
                                      </Typography>
                                    </Tooltip>
                                  )}
                                </Box>
                              </div>
                            </div>
                            <div
                              style={{
                                alignSelf: 'stretch',
                                height: 28,
                                paddingTop: 6,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                display: 'inline-flex',
                              }}
                            >
                              <div
                                style={{
                                  justifyContent: 'flex-start',
                                  alignItems: 'flex-start',
                                  gap: 8,
                                  display: 'flex',
                                }}
                              >
                                <div
                                  style={{
                                    color: '#090C0D',
                                    fontSize: 12,
                                    fontFamily: 'Poppins',
                                    fontWeight: '500',
                                    wordWrap: 'break-word',
                                  }}
                                >
                                  Partner:
                                </div>
                                <div
                                  style={{
                                    width: kmz.partner.length > 7 ? 75 : 55,
                                    paddingLeft: 6,
                                    paddingRight: 6,
                                    paddingTop: 2,
                                    paddingBottom: 2,
                                    background: getPartnerColor(kmz.partner),
                                    borderRadius: 3,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    display: 'flex',
                                  }}
                                >
                                  <div
                                    style={{
                                      color: 'white',
                                      fontSize: 12,
                                      fontFamily: 'Poppins',
                                      fontWeight: '500',
                                      wordWrap: 'break-word',
                                    }}
                                  >
                                    {kmz.partner}
                                  </div>
                                </div>
                              </div>
                              {/* <div style={{ color: 'rgba(116.59, 127, 130.47, 0.75)', fontSize: 12, fontFamily: 'Poppins', fontWeight: '500', wordWrap: 'break-word' }}>{formatDateWithAtTime(kmz?.uploadedAt)}</div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>No Data Available</div>
                )}
                {/* <div style={{ height: 32, paddingLeft: 12, paddingRight: 12, paddingTop: 69, paddingBottom: 69, boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 4, overflow: 'hidden', justifyContent: 'center', alignItems: 'center', display: 'inline-flex' }}>
                                    <div style={{ paddingLeft: 8, paddingRight: 8, justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex' }}>
                                        <div style={{ color: '#BD1D23', fontSize: 14, fontFamily: 'Poppins', fontWeight: '500', textDecoration: 'underline', lineHeight: 16.80, wordWrap: 'break-word' }} onClick={()=>setLoad(true)}>Load More</div>
                                    </div>
                                </div> */}
              </div>
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
};
